<template>
	<main-container>
		<material-card icon="fas fa-user" :title="$t('adminusers.table_title')" :exportElement="{ element: 'AdminUsers', types: ['xls'] }" :main_action="main_action" @mainAction="newAdminUsers" :selected="selected_adminusers" @unselectAll="selected_adminusers = []">
			<template slot="selection-actions">
				<v-btn class="ma-1 mr-0" v-if="allSelectedCanHaveCredential" @click="generateAdminUsersCredentials" small outlined :disabled="adminuserscredentials_generating" :loading="adminuserscredentials_generating" color="warning">
					{{ $t("adminusers.generatecredentials_title") }}
					<v-icon small class="pl-1">fas fa-unlock-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="5">
					<search-box v-model="adminusers_options.search" nocolor @change="adminusers_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table @click-action="editAdminUsers" :selected.sync="selected_adminusers" show-select :headers="adminusers_headers" :items="adminusers.data" :options.sync="adminusers_options" :server-items-length="adminusers.total" :loading="adminusers_loading">
				<template v-slot:item.active="{ item }">
					<v-icon color="success" v-if="item.active">fas fa-check</v-icon>
					<template v-else>
						<v-icon color="error">fas fa-times</v-icon>
					</template>
				</template>
			</material-table>
		</material-card>
		<create-edit-adminusers v-if="showCreateEditAdminUsers"></create-edit-adminusers>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originaladminusers_options: null,
		selected_adminusers: [],
	}),
	computed: {
		allSelectedCanHaveCredential() {
			let status = true;
			for (let element of this.selected_adminusers) {
				if (element.active == true) {
					status = false;
					break;
				}
			}
			return status;
		},
		showImportAdminUsers() {
			return this.$store.getters.showImportAdminUsers;
		},
		showCreateEditAdminUsers() {
			return this.$store.getters.showCreateEditAdminUsers;
		},
		main_action() {
			return {
				icon: "fas fa-plus",
				text: this.$vuetify.breakpoint.xsOnly ? this.$t("adminusers.mainaction_mobile") : this.$t("adminusers.mainaction"),
			};
		},
		adminusers_headers() {
			let headers = [];
			headers.push({
				text: this.$t("incomedeclarations.tenant"),
				value: "tenant.fullname",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("adminusers.surname"),
				value: "surname",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("adminusers.name"),
				value: "name",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("adminusers.email"),
				value: "email",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("adminusers.phone_number"),
				value: "phone_number",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("adminusers.active"),
				value: "active",
				align: "center",
				sortable: false,
			});
			return { data: headers, id: "adminusers_headers" };
		},
		adminusers_options: {
			get: function () {
				return this.$store.getters.getAdminUsersOptions;
			},
			set: function (value) {
				this.$store.commit("setAdminUsersOptions", value);
			},
		},
		adminusers() {
			return this.$store.getters.getAdminUsers;
		},
		adminusers_loading() {
			return this.$store.getters.adminusers_loading;
		},
		adminuserscredentials_generating() {
			return this.$store.getters.adminuserscredentials_generating;
		},
	},
	methods: {
		loadAdminUsers() {
			const self = this;
			if (self.$functions.ObjectAreEqual(self.originaladminusers_options, self.adminusers_options) == false) {
				self.originaladminusers_options = _.cloneDeep(self.adminusers_options);
				self.$store.dispatch("fetchAdminUsers");
			}
		},
		newAdminUsers(selected) {
			let isCopy = false;
			if (selected) {
				delete selected.id;
				isCopy = true;
			} else {
				selected = {
					fullname: null,
				};
			}
			this.$store.commit("setCurrentAdminUsers", _.cloneDeep(selected));
			this.$store.dispatch("showAction", "showCreateEditAdminUsers");
			if (isCopy) {
				selected.fullname = selected.fullname ? selected.fullname + " " + this.$t("global.append_copy") : this.$t("global.append_copy");
				this.$nextTick(() => {
					this.$store.commit("setCurrentAdminUsers", _.cloneDeep(selected));
				});
			}
		},
		editAdminUsers(item) {
			this.$store.commit("setCurrentAdminUsers", _.cloneDeep(item));
			this.$store.dispatch("showAction", "showCreateEditAdminUsers");
		},
		generateAdminUsersCredentials() {
			const self = this;
			let message = self.$t("adminusers.generatecredentials_message_pre");
			if (self.selected_adminusers.length <= 1) {
				message += self.$t("adminusers.question_selected");
			} else {
				message += self.selected_adminusers.length + self.$t("adminusers.question_multiple_selected");
			}
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("adminusers.generatecredentials_title"),
				message: message,
				okCb: () => {
					self.$store.dispatch("generateAdminUserCredentials", _.map(self.selected_adminusers, _.property("id"))).then((res) => {
						self.$functions.actionOnSelection(res, self.selected_adminusers);
					});
				},
			});
		},
	},
	watch: {
		adminusers_options: {
			handler(val) {
				this.loadAdminUsers();
			},
			deep: true,
		},
	},
};
</script>
